import request from '@/utils/request';
// 问卷列表
export const getQuestionnaire = (params: any) =>
  request({
    url: 'QuestionBank/questionnaire',
    method: 'get',
    params
  });
  // 添加问卷
export const addQuestionnaire = (data: any) =>
  request({
    url: 'QuestionBank/questionnaire',
    method: 'POST',
    data
  });
// 添加问卷问题
export const addQuestionnaireQuestion = (data: any) =>
  request({
    url: 'QuestionBank/questionnaireQuestion',
    method: 'POST',
    data
  });
export const editQuestionnaire = (data: any) =>
  request({
    url: 'QuestionBank/questionnaire',
    method: 'PUT',
    data
  });
export const delQuestionnaire = (data: any) =>
  request({
    url: 'QuestionBank/questionnaire',
    method: 'DELETE',
    data
  });

// 题库 列表
export const getQuestionBank = (params: any) =>
  request({
    url: 'QuestionBank/questionBank',
    method: 'get',
    params
  });
// 增加-问答题
export const addQuestionBank = (data: any) =>
  request({
    url: 'QuestionBank/questionBank',
    method: 'POST',
    data
  });
export const editQuestionBank = (data: any) =>
  request({
    url: 'QuestionBank/questionBank',
    method: 'PUT',
    data
  });
export const delQuestionBank = (data: any) =>
  request({
    url: 'QuestionBank/questionBank',
    method: 'DELETE',
    data
  });
